import React, { useState } from 'react';
import { FileText, Download, Eye, AlertCircle, FileSpreadsheet } from 'lucide-react';
import { downloadRoomReport, previewRoomReport, exportToGoogleSheets } from '../../services/roomReportService';

const ReportButton = ({ roomNo, disabled = false, className = '', sortedData = null, activeFilters = null }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showMenu, setShowMenu] = useState(false);

  const handleDownload = async () => {
    try {
      setLoading(true);
      setError(null);
      await downloadRoomReport(roomNo, sortedData, activeFilters);
      setShowMenu(false);
    } catch (error) {
      setError(error.message || 'Failed to generate report');
    } finally {
      setLoading(false);
    }
  };

  const handlePreview = async () => {
    try {
      setLoading(true);
      setError(null);
      await previewRoomReport(roomNo, sortedData, activeFilters);
      setShowMenu(false);
    } catch (error) {
      setError(error.message || 'Failed to preview report');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleSheets = async () => {
    try {
      setLoading(true);
      setError(null);
      await exportToGoogleSheets(roomNo, sortedData, activeFilters);
      setShowMenu(false);
    } catch (error) {
      setError(error.message || 'Failed to export to Google Sheets');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`report-button-container ${className}`} style={{ position: 'relative' }}>
      <button
        onClick={() => setShowMenu(!showMenu)}
        disabled={disabled || loading}
        className="traffic-btn btn-primary"
        style={{ 
          minWidth: 'auto', 
          padding: '12px 16px', 
          fontSize: '16px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
      >
        <FileText className="btn-icon" />
        {loading ? 'Generating...' : 'Generate Report'}
      </button>

      {showMenu && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: '0',
          marginTop: '4px',
          backgroundColor: 'var(--mfg-dark-elevated)',
          border: '1px solid var(--mfg-dark-border)',
          borderRadius: '8px',
          boxShadow: '0 4px 12px var(--mfg-shadow-color)',
          zIndex: 1000,
          minWidth: '200px'
        }}>
          <button
            onClick={handlePreview}
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: 'none',
              backgroundColor: 'transparent',
              color: 'var(--mfg-text-primary)',
              fontSize: '14px',
              textAlign: 'left',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              borderRadius: '8px 8px 0 0'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--mfg-dark-border)'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <Eye style={{ width: '16px', height: '16px' }} />
            Preview Report
          </button>
          
          <button
            onClick={handleGoogleSheets}
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: 'none',
              backgroundColor: 'transparent',
              color: 'var(--mfg-text-primary)',
              fontSize: '14px',
              textAlign: 'left',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--mfg-dark-border)'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <FileSpreadsheet style={{ width: '16px', height: '16px' }} />
            Export to Google Sheets
          </button>

          <button
            onClick={handleDownload}
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px 16px',
              border: 'none',
              backgroundColor: 'transparent',
              color: 'var(--mfg-text-primary)',
              fontSize: '14px',
              textAlign: 'left',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              borderRadius: '0 0 8px 8px'
            }}
            onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--mfg-dark-border)'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <Download style={{ width: '16px', height: '16px' }} />
            Download PDF
          </button>
        </div>
      )}

      {error && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: '0',
          marginTop: '4px',
          padding: '8px 12px',
          backgroundColor: 'rgba(220, 38, 38, 0.1)',
          border: '1px solid rgba(220, 38, 38, 0.3)',
          borderRadius: '4px',
          color: '#dc2626',
          fontSize: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          zIndex: 1001
        }}>
          <AlertCircle style={{ width: '14px', height: '14px' }} />
          {error}
        </div>
      )}

      {/* Click outside to close menu */}
      {showMenu && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 999
          }}
          onClick={() => setShowMenu(false)}
        />
      )}
    </div>
  );
};

export default ReportButton;